// custom typefaces
import '@fontsource/lora/400.css'
import '@fontsource/lora/400-italic.css'
import '@fontsource/lora/700.css'
import '@fontsource/lora/700-italic.css'

import 'prismjs/themes/prism.css'

import './src/style.css'